module.exports = __webpack_public_path__ + "static/caisse-1-d3b93125e39a1e5d8630861d84fd2d77.png";